import { translationClearanceStatuses } from "../data";

export const ValorationPatientAssessmentMade = ({
  numberEvents,
  protocol,
  clearanceStatus,
  clearanceNote,
}) => {
  return (
    <div className="table-responsive shadow rounded">
      <table className="table table-center bg-white mb-0">
        <thead className="table-primary">
          <tr>
            <th className="border-bottom p-3">Indicador</th>
            <th className="border-bottom p-3">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="py-3">Protocolo</td>
            <td className="py-3">{protocol}</td>
          </tr>
          <tr>
            <td className="py-3">Número de sesiones</td>
            <td className="py-3">{numberEvents}</td>
          </tr>
          {clearanceStatus !== null && (
            <tr>
              <td className="py-3">Autorizado para procedimiento</td>
              <td className="py-3">
                {translationClearanceStatuses[clearanceStatus]}
              </td>
            </tr>
          )}
          {clearanceNote !== null && (
            <tr>
              <td className="py-3">Motivo</td>
              <td className="py-3">{clearanceNote}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
